import React, { useState, useEffect } from 'react'
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api'
import { useTranslation } from 'i18n'

const mapOptions = {
  styles: [
    {
      featureType: 'all',
      elementType: 'all',
      stylers: [
        {
          saturation: '32',
        },
        {
          lightness: '-3',
        },
        {
          visibility: 'on',
        },
        {
          weight: '1.18',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.province',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'on',
        },
        {
          weight: '1.79',
        },
        {
          saturation: '19',
        },
        {
          lightness: '-20',
        },
      ],
    },
    {
      featureType: 'administrative.province',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'administrative.neighborhood',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'administrative.land_parcel',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'all',
      stylers: [
        {
          saturation: '-70',
        },
        {
          lightness: '14',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          saturation: '100',
        },
        {
          lightness: '-14',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
        {
          lightness: '12',
        },
      ],
    },
  ],
}

const Map = ({ locations, children }) => {
  const { t } = useTranslation('locator')
  const initialCenter = { lat: 42.374063, lng: -71.043045 } //downtown boston
  const [mapObject, setMapObject] = useState({})
  const [coordinates, setCoordinates] = useState({})

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY,
  })

  useEffect(() => {
    setCoordinates(initialCenter)
  }, [])

  useEffect(() => {
    if (isLoaded === true && locations && locations.length > 0) {
      const bounds = new window.google.maps.LatLngBounds()
      locations.forEach(function (location) {
        bounds.extend(location.coordinates)
      })
      setCoordinates(locations[0])
      mapObject.fitBounds(bounds)
    }
  }, [locations])

  const onMapLoad = map => {
    setMapObject(map)
  }

  const containerStyle = {
    width: '400px',
    height: '400px',
  }

  const renderMap = () => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={coordinates}
        options={mapOptions}
        onLoad={onMapLoad}
        zoom={9}
      >
        {children}
      </GoogleMap>
    )
  }

  if (loadError) {
    return <div>{t('error.mapLoad')}</div>
  }

  return isLoaded ? renderMap() : <></>
}
export default Map
